export const formatName = (firstName?: string, lastName?: string): string => {
  if (firstName && lastName) {
    firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase();
    return firstName + " " + lastName;
  } else {
    return "";
  }
};
